import PropTypes from 'prop-types';
import React, { createContext, useContext, useState } from 'react';

import webfox from './webbase';
import { StoreContext, actions } from './webstore';

const WebfoxContext: any = createContext<{
  fetchRecommendations: () => null;
}>({
  fetchRecommendations: () => null,
});

// const WebfoxContext: any = React.createContext({});

const WebfoxProvider: React.FC = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const { state, actionDispatch } = useContext(StoreContext);

  return (
    <WebfoxContext.Provider
      value={{
        webfox,
        loading,
        setLoading,
        // web store
        webstore: state,
        actions,
        actionDispatch,
      }}
    >
      {children}
    </WebfoxContext.Provider>
  );
};

WebfoxProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

export { WebfoxContext, WebfoxProvider };
